import type { ReactNode } from 'react';

type IconComponent = (props: { className?: string }) => ReactNode;

type ToastProps = {
  message: string;
  icon: IconComponent;
  show: boolean;
  onClick?: () => void;
  selfClosing?: boolean;
  className?: string;
};

const baseClassName =
  'fixed top-4 inset-x-4 z-50 items-start gap-3 rounded border p-4 shadow-lg backdrop-blur-sm md:inset-x-auto md:right-4 md:left-auto md:w-full md:max-w-xs';

export const Toast = ({ message, icon, show, onClick, selfClosing, className }: ToastProps) => {
  return (
    <div className={`${show ? 'flex' : 'hidden'} ${baseClassName} ${className ?? ''}`} role="alert">
      <div className="inline-flex h-5 w-5 shrink-0 items-center justify-center">
        {icon && icon({ className: 'size-5' })}
      </div>
      <div className="text-sm leading-snug font-medium">{message}</div>
      {!selfClosing && (
        <button
          type="button"
          className="-mx-1 -my-1 ms-auto inline-flex h-7 w-7 shrink-0 items-center justify-center rounded transition-opacity hover:opacity-70 focus:ring-2 focus:outline-none"
          aria-label="Close"
          onClick={onClick}
        >
          <span className="sr-only">Close</span>
          <svg
            className="h-3 w-3"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 14 14"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
            />
          </svg>
        </button>
      )}
    </div>
  );
};
